import { Children, FunctionComponent, ReactElement, useState } from 'react';
import { ScrollableTabs, TabTextVariant } from 'wisestep-base';

interface WsTabsProps {
  onChange?(index: number): void;
  variant?: TabTextVariant;
  tabPanelPage?: number;
}

export const WsTabs: FunctionComponent<WsTabsProps> & WsTabsComposition = (props) => {
  const [tabPanelPage, setTabPanelPage] = useState(props.tabPanelPage ?? 0);
  const children = Children.toArray(props.children);

  return (
    <>
      <ScrollableTabs
        variant={props.variant ?? TabTextVariant.SUB_TITLE}
        scrollList={children.map((child) => ({
          tabName: (child as ReactElement<WsTabsItemProps>).props.label,
        }))}
        getTabIndex={(index) => {
          setTabPanelPage(index);
          props.onChange && props.onChange(index);
        }}
        defaultValue={tabPanelPage}
      />
      {(children[tabPanelPage] as ReactElement)?.props.children}
    </>
  );
};

interface WsTabsComposition {
  Item: FunctionComponent<WsTabsItemProps>;
}

interface WsTabsItemProps {
  label: string;
}

const WsTabsItem = () => <></>;

WsTabs.Item = WsTabsItem;
